import proiectSMIS from "../assets/proiect-smis.png";

export const ProiectSMIS = () => {
    return (
        <div style={{ margin: "auto", width: "60%", height: "auto" }}>
            <img src={proiectSMIS} alt="Proiect SMIS" style={{ width: "100%", height: "auto" }} />
        </div>
    );
};
